import React, { useState, useEffect } from "react";
import { useWeb3 } from "./js/useWeb3";
import walletImg1 from "../img/walletImg1.png";
import walletImg2 from "../img/walletImg2.png";
import walletImg3 from "../img/walletImg3.png";
import walletImg4 from "../img/walletImg4.png";
import walletImg5 from "../img/walletImg5.png";
import walletImg6 from "../img/walletImg6.png";
import closeIcon from "../img/close.png";
import "./css/walletPop.less";

const walletList = [
  { img: walletImg1, name: "MetaMask", type: "metamask" },
  { img: walletImg2, name: "OKX EVEM Wallet", type: "okx" },
  { img: walletImg3, name: "Bitget EVM Wallet", type: "bitkeep" },
  { img: walletImg4, name: "TokenPocket", type: "tokenpocket" },
  { img: walletImg5, name: "Coin98 EVM Wallet", type: "coin98" },
  { img: walletImg6, name: "Gate Web3", type: "gate" },
];

const ConnectWalletPopup = ({ onClose, onConnect }) => {
  const [popState, setPopState] = useState(false);
  const isHasWallet = !!((window as any).ethereum);
  const { connect } = useWeb3();

  useEffect(() => {
    setTimeout(() => {
      setPopState(true);
    }, 0);
  }, []);

  const handleConnectWallet = async (type) => {
    const address = await connect(type);
    console.log(address, "钱包地址");
    onConnect(address);
  };

  const handleClose = () => {
    setPopState(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  return (
    <div className="whole">
      {popState && (
        <div className="popBox">
          <div className="topTitle">
            <div>
              <div>Connect wallet</div>
              <span>Connect your wallet to transfer tokens</span>
            </div>
            <img src={closeIcon} alt="" onClick={handleClose} />
          </div>

          <div className="wallBox">
            {isHasWallet ? (
              walletList.map((item) => (
                <div key={item.name} className="wallItem" onClick={() => handleConnectWallet(item.type)}>
                  <img src={item.img} alt="" />
                  <span>{item.name}</span>
                </div>
              ))
            ) : (
              <div style={{ display: "flex", justifyContent: "center", minHeight: "150px", alignItems: "center", flex: 1 }}>
                暂无可用钱包
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ConnectWalletPopup;
